import * as R from 'ramda'

export const ellipsisAfter = R.curry((n, s) =>
  s.length > n ? `${s.substr(0, n)}\u2026` : s)
